export default __webpack_public_path__ + "static/media/bingoGame.35a2ef09.png";